import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPinIcon, CalendarIcon, ChevronRightIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { BottomNav } from '../components/BottomNav';
import { DriverToggle } from '../components/DriverToggle';
import { useApp } from '../context/AppContext';
export const Home: React.FC = () => {
  const navigate = useNavigate();
  const {
    user,
    savedLocations,
    setCurrentRide
  } = useApp();
  const [pickup, setPickup] = useState('');
  const [dropoff, setDropoff] = useState('');
  const [selectedRideType, setSelectedRideType] = useState('Standard');
  const rideTypes = ['Standard', 'Premium', 'Shared Shuttle', 'Airport'];
  const getTimeOfDay = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'morning';
    if (hour < 18) return 'afternoon';
    return 'evening';
  };
  const handleBookNow = () => {
    setCurrentRide({
      pickup: savedLocations.find(loc => loc.name.toLowerCase().includes(pickup.toLowerCase())) || {
        id: 'custom',
        name: pickup,
        address: pickup,
        country: 'MY'
      },
      dropoff: savedLocations.find(loc => loc.name.toLowerCase().includes(dropoff.toLowerCase())) || {
        id: 'custom',
        name: dropoff,
        address: dropoff,
        country: 'SG'
      }
    });
    navigate('/ride-options');
  };
  const handleScheduleRide = () => {
    if (pickup && dropoff) {
      const pickupLocation = savedLocations.find(loc => loc.name.toLowerCase().includes(pickup.toLowerCase())) || {
        id: 'custom',
        name: pickup,
        address: pickup,
        country: 'MY' as const
      };
      const dropoffLocation = savedLocations.find(loc => loc.name.toLowerCase().includes(dropoff.toLowerCase())) || {
        id: 'custom',
        name: dropoff,
        address: dropoff,
        country: 'SG' as const
      };
      navigate('/schedule', {
        state: {
          pickup: pickupLocation,
          dropoff: dropoffLocation
        }
      });
    } else {
      navigate('/schedule');
    }
  };
  return <div className="min-h-screen bg-background pb-16" data-id="element-396">
      <div className="p-6" data-id="element-397">
        <div className="flex items-center justify-between mb-8" data-id="element-398">
          <div data-id="element-399">
            <h1 className="text-2xl font-semibold" data-id="element-400">
              Good {getTimeOfDay()}, {user.name || 'there'}
            </h1>
            <p className="text-white text-opacity-70" data-id="element-401">
              Where are you going today?
            </p>
          </div>
          <div className="flex items-center space-x-3" data-id="element-402">
            <DriverToggle data-id="element-403" />
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tZW1cXVNSUAs8uLdQVnHaK/jomgo.png" alt="JomGo" className="h-10" data-id="element-404" />
          </div>
        </div>
        <div className="mb-8" data-id="element-405">
          <div className="mb-3" data-id="element-406">
            <Input icon="location" placeholder="Pickup location" value={pickup} onChange={e => setPickup(e.target.value)} data-id="element-407" />
          </div>
          <div className="mb-3" data-id="element-408">
            <Input icon="location" placeholder="Dropoff location" value={dropoff} onChange={e => setDropoff(e.target.value)} data-id="element-409" />
          </div>
        </div>
        <div className="mb-8" data-id="element-410">
          <h2 className="text-lg font-medium mb-3" data-id="element-411">Quick routes</h2>
          <div className="space-y-2" data-id="element-412">
            {savedLocations.map(location => <div key={location.id} className="card flex justify-between items-center" onClick={() => {
            if (location.country === 'MY') {
              setPickup(location.name);
            } else {
              setDropoff(location.name);
            }
          }} data-id="element-413">
                <div className="flex items-center" data-id="element-414">
                  <MapPinIcon size={20} className="text-primary mr-3" data-id="element-415" />
                  <div data-id="element-416">
                    <p className="font-medium" data-id="element-417">{location.name}</p>
                    <p className="text-sm text-white text-opacity-70" data-id="element-418">
                      {location.address}
                    </p>
                  </div>
                </div>
                <ChevronRightIcon size={20} className="text-primary" data-id="element-419" />
              </div>)}
          </div>
        </div>
        <div className="mb-8" data-id="element-420">
          <h2 className="text-lg font-medium mb-3" data-id="element-421">Ride type</h2>
          <div className="flex overflow-x-auto space-x-3 pb-2 -mx-1 px-1" data-id="element-422">
            {rideTypes.map(type => <div key={type} className={`flex-shrink-0 px-4 py-3 rounded-lg border ${selectedRideType === type ? 'border-primary bg-primary bg-opacity-10' : 'border-white border-opacity-20'}`} onClick={() => setSelectedRideType(type)} data-id="element-423">
                <span className={selectedRideType === type ? 'text-primary' : ''} data-id="element-424">
                  {type}
                </span>
              </div>)}
          </div>
        </div>
        <div className="space-y-3" data-id="element-425">
          <Button onClick={handleBookNow} data-id="element-426">Book Now</Button>
          <Button variant="secondary" onClick={handleScheduleRide} className="flex items-center justify-center" data-id="element-427">
            <CalendarIcon size={18} className="mr-2" data-id="element-428" />
            Schedule Ride
          </Button>
        </div>
      </div>
      <BottomNav data-id="element-429" />
    </div>;
};